import { render, staticRenderFns } from "./listNotation.vue?vue&type=template&id=cd23946e&scoped=true"
import script from "./listNotation.vue?vue&type=script&lang=js"
export * from "./listNotation.vue?vue&type=script&lang=js"
import style0 from "./listNotation.vue?vue&type=style&index=0&id=cd23946e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd23946e",
  null
  
)

export default component.exports